(() => {
  const KEY = 'sth_saved_items';
  const moneyFormat = document.documentElement.dataset.moneyFormat || '${{amount}}';
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  };
  const write = (items) => {
    localStorage.setItem(KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('sth:saved-change', { detail: { items } }));
    updateUI();
  };
  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;',
  })[character]);
  const formatMoney = (cents) => {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents, moneyFormat);
    const value = Number(cents || 0) / 100;
    const token = moneyFormat.match(/\{\{\s*(amount[^}]*)\}\}/)?.[1] || 'amount';
    let amount;
    if (token.includes('no_decimals')) amount = Math.round(value).toLocaleString();
    else amount = value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };
  let toastTimer;
  const toast = (message) => {
    let element = document.querySelector('.sth-saved-toast');
    if (!element) {
      element = document.createElement('div');
      element.className = 'sth-saved-toast';
      element.setAttribute('role', 'status');
      document.body.appendChild(element);
    }
    element.textContent = message;
    element.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => element.classList.remove('is-visible'), 1500);
  };
  const optionValue = (options, name) => {
    const entry = Object.entries(options || {}).find(([key]) => key.toLowerCase() === name.toLowerCase());
    return entry ? String(entry[1] || '') : '';
  };
  const savedKey = (item) => {
    const handle = String(item?.handle || '');
    const variantId = String(item?.variantId || '');
    if (variantId) return `${handle}-${variantId}`;
    const color = optionValue(item?.options, 'Color');
    return color ? `${handle}-${color.toLowerCase().replace(/[^a-z0-9]+/g, '-')}` : handle;
  };
  const itemFromButton = (button) => {
    const container = button.closest('.product__info-container');
    const form = container?.querySelector('form[action*="/cart/add"]');
    const formVariant = form?.querySelector('[name="id"]')?.value || '';
    const variantId = button.dataset.sthContext === 'product' ? formVariant : button.dataset.variantId;
    const options = {};
    container?.querySelectorAll('input[type="radio"]:checked, select').forEach((input) => {
      const name = (input.name || '').replace(/^options\[|\]$/g, '');
      if (name && input.value) options[name] = input.value;
    });
    const item = {
      handle: button.dataset.productHandle,
      productUrl: button.dataset.productUrl,
      variantId: String(variantId || ''),
      title: button.dataset.productTitle,
      image: button.dataset.productImage,
      price: Number(button.dataset.price || 0),
      compareAtPrice: Number(button.dataset.compareAtPrice || 0),
      options,
      savedAt: new Date().toISOString(),
    };
    item.key = savedKey(item);
    return item;
  };
  const updateUI = () => {
    const items = read();
    document.querySelectorAll('[data-sth-save]').forEach((button) => {
      const candidate = itemFromButton(button);
      const item = items.find((entry) => savedKey(entry) === candidate.key);
      button.classList.toggle('is-saved', Boolean(item));
      button.setAttribute('aria-pressed', item ? 'true' : 'false');
      const label = button.querySelector('.sth-save-button__label');
      if (button.dataset.sthContext === 'product') {
        if (label) label.textContent = item ? 'Saved' : 'Save for later';
      } else {
        const text = `${item ? 'Remove' : 'Save'} ${button.dataset.productTitle}${item ? ' from saved' : ''}`;
        button.setAttribute('aria-label', text);
        if (label) label.textContent = text;
      }
    });
    document.querySelectorAll('[data-sth-saved-count]').forEach((count) => {
      count.textContent = items.length;
      count.hidden = items.length === 0;
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sth-save]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const items = read();
    const candidate = itemFromButton(button);
    const index = items.findIndex((item) => savedKey(item) === candidate.key);
    if (index >= 0) {
      items.splice(index, 1);
      write(items);
      toast('Removed.');
    } else {
      items.unshift(candidate);
      write(items);
      toast('Saved.');
    }
  });
  document.addEventListener('change', (event) => {
    if (!event.target.closest('.product__info-container')) return;
    const button = document.querySelector('.sth-save-button--product');
    if (!button) return;
    setTimeout(() => {
      const id = button.closest('.product__info-container')?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      if (id) button.dataset.variantId = id;
      updateUI();
    }, 0);
  });
  window.addEventListener('storage', updateUI);
  window.addEventListener('sth:saved-change', updateUI);

  const FALLBACK_SHOP_URL = '/collections/all';
  const getSavedReturnUrl = () => {
    let value = '';
    try {
      value = sessionStorage.getItem('sth_saved_return_url') || '';
    } catch (error) {
      return FALLBACK_SHOP_URL;
    }
    if (!value) return FALLBACK_SHOP_URL;
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || url.pathname === '/pages/saved') return FALLBACK_SHOP_URL;
      return url.href;
    } catch (error) {
      return FALLBACK_SHOP_URL;
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.sth-saved-link');
    if (!link || window.location.pathname === '/pages/saved') return;
    try {
      sessionStorage.setItem('sth_saved_return_url', window.location.href);
    } catch (error) {
      // Keep the Saved link functional when storage is unavailable.
    }
  });

  const productCard = (item, product) => {
    if (!product) return `<article class="sth-saved-card" data-handle="${escapeHtml(item.handle)}" data-saved-key="${escapeHtml(savedKey(item))}"><a class="sth-saved-card__image" href="${escapeHtml(item.productUrl)}">${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}">` : ''}</a><div class="sth-saved-card__body"><span class="sth-saved-card__title">${escapeHtml(item.title)}</span><p class="sth-saved-card__price"></p><div class="sth-saved-card__size" aria-hidden="true"></div><p class="sth-saved-card__message">Unavailable.</p><button type="button" class="sth-saved-card__remove" data-saved-remove>Remove</button></div></article>`;
    const variants = product.variants || [];
    const sizeIndex = (product.options || []).findIndex((option) => String(option.name || option).toLowerCase() === 'size');
    const optionDefinitions = product.options || [];
    const savedColor = optionValue(item.options, 'Color');
    const explicitSavedSize = optionValue(item.options, 'Size');
    let current = item.variantId
      ? variants.find((variant) => String(variant.id) === String(item.variantId))
      : null;
    if (!current && explicitSavedSize) {
      current = variants.find((variant) => optionDefinitions.every((option, index) => {
        const name = String(option.name || option);
        if (name.toLowerCase() === 'size') return String(variant.options?.[index] || '') === explicitSavedSize;
        if (name.toLowerCase() === 'color' && savedColor) return String(variant.options?.[index] || '') === savedColor;
        return true;
      })) || null;
    }
    const savedSize = sizeIndex >= 0 ? (explicitSavedSize || String(current?.options?.[sizeIndex] || '')) : '';
    const hasSavedSize = savedSize !== '';
    const selectedVariant = hasSavedSize ? current : null;
    const image = current?.featured_image?.src || product.featured_image || item.image;
    const price = current?.price ?? product.price;
    const compare = current?.compare_at_price ?? product.compare_at_price;
    let selector = '<div class="sth-saved-card__size" aria-hidden="true"></div>';
    if (sizeIndex >= 0) {
      const sizes = [...new Set(variants.map((variant) => variant.options[sizeIndex]))];
      selector = `<div class="sth-saved-card__size"><select class="sth-saved-card__select" data-saved-size aria-label="Size"><option value="">Select a size</option>${sizes.map((size) => {
        const available = variants.some((variant) => {
          if (String(variant.options?.[sizeIndex] || '') !== String(size) || !variant.available) return false;
          return optionDefinitions.every((option, index) => {
            if (index === sizeIndex) return true;
            const name = String(option.name || option);
            const savedValue = optionValue(item.options, name) || current?.options?.[index];
            return !savedValue || String(variant.options?.[index] || '') === String(savedValue);
          });
        });
        const selected = hasSavedSize && savedSize === String(size) ? ' selected' : '';
        return `<option value="${escapeHtml(size)}"${available ? '' : ' disabled'}${selected}>${escapeHtml(size)}${available ? '' : ' — Sold Out'}</option>`;
      }).join('')}</select></div>`;
    }
    const initialVariant = selectedVariant || (sizeIndex < 0 ? current : null);
    return `<article class="sth-saved-card" data-handle="${escapeHtml(item.handle)}" data-saved-key="${escapeHtml(savedKey(item))}" data-product='${escapeHtml(JSON.stringify(product))}'><a class="sth-saved-card__image" href="${escapeHtml(item.productUrl)}"><img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}"></a><div class="sth-saved-card__body"><a class="sth-saved-card__title" href="${escapeHtml(item.productUrl)}">${escapeHtml(product.title)}</a><p class="sth-saved-card__price"><span data-saved-price>${formatMoney(price)}</span>${compare && compare > price ? `<span class="sth-saved-card__compare">${formatMoney(compare)}</span>` : ''}</p>${selector}<button type="button" class="sth-saved-card__add" data-saved-add data-variant-id="${initialVariant?.id || ''}" ${initialVariant && !initialVariant.available ? 'disabled' : ''}>${initialVariant && !initialVariant.available ? 'Sold Out' : 'Add to Cart'}</button><p class="sth-saved-card__message" data-saved-message aria-live="polite"></p><button type="button" class="sth-saved-card__remove" data-saved-remove>Remove</button></div></article>`;
  };
  const renderPage = async () => {
    const root = document.querySelector('[data-sth-saved-page]');
    if (!root) return;
    const grid = root.querySelector('[data-saved-grid]');
    const empty = root.querySelector('[data-saved-empty]');
    const status = root.querySelector('[data-saved-status]');
    const populatedBack = root.querySelector('[data-saved-populated-back]');
    const items = read();
    root.querySelectorAll('[data-saved-back]').forEach((link) => {
      link.href = getSavedReturnUrl();
    });
    if (populatedBack) populatedBack.hidden = items.length === 0;
    grid.innerHTML = '';
    empty.hidden = items.length !== 0;
    if (!items.length) {
      status.textContent = '';
      return;
    }
    const entries = await Promise.all(items.map(async (item) => {
      try {
        const response = await fetch(`/products/${encodeURIComponent(item.handle)}.js`);
        if (!response.ok) throw new Error('Unavailable');
        return { item, product: await response.json() };
      } catch (error) {
        return { item, product: null };
      }
    }));
    grid.innerHTML = entries.map(({ item, product }) => productCard(item, product)).join('');
    status.textContent = '';
  };
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-saved-size]')) return;
    const card = event.target.closest('.sth-saved-card');
    const product = JSON.parse(card.dataset.product);
    const sizeIndex = product.options.findIndex((option) => String(option.name || option).toLowerCase() === 'size');
    const add = card.querySelector('[data-saved-add]');
    const selectedSize = event.target.value;
    if (!selectedSize) {
      add.dataset.variantId = '';
      add.disabled = false;
      add.textContent = 'Add to Cart';
      return;
    }

    const items = read();
    const saved = items.find((item) => savedKey(item) === card.dataset.savedKey);
    const current = product.variants.find((entry) => String(entry.id) === String(saved?.variantId || ''));
    const optionValues = saved?.options || {};
    const variant = product.variants.find((entry) => {
      if (String(entry.options[sizeIndex]) !== selectedSize) return false;
      return product.options.every((option, index) => {
        if (index === sizeIndex) return true;
        const optionName = option.name || option;
        const savedValue = optionValues[optionName] || current?.options?.[index];
        return !savedValue || String(entry.options[index]) === String(savedValue);
      });
    });

    if (!variant) {
      add.dataset.variantId = '';
      add.disabled = false;
      add.textContent = 'Add to Cart';
      card.querySelector('[data-saved-message]').textContent = 'This option is unavailable.';
      return;
    }

    add.dataset.variantId = variant.id;
    add.disabled = !variant.available;
    add.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    card.querySelector('[data-saved-price]').textContent = formatMoney(variant.price);
    card.querySelector('[data-saved-message]').textContent = '';
    if (saved) {
      saved.variantId = String(variant.id);
      saved.options = Object.fromEntries(product.options.map((option, index) => [option.name || option, variant.options[index]]));
      saved.key = savedKey(saved);
      card.dataset.savedKey = saved.key;
      write(items);
    }
  });
  const getCurrentSavedVariant = (card) => {
    let product;
    try {
      product = JSON.parse(card.dataset.product || '{}');
    } catch (error) {
      return { error: 'Unable to add to cart.' };
    }

    const variants = Array.isArray(product.variants) ? product.variants : [];
    const optionDefinitions = Array.isArray(product.options) ? product.options : [];
    const sizeIndex = optionDefinitions.findIndex(
      (option) => String(option.name || option).toLowerCase() === 'size'
    );
    const selector = card.querySelector('[data-saved-size]');
    const selectedSize = selector?.value || '';
    const items = read();
    const saved = items.find((item) => savedKey(item) === card.dataset.savedKey);
    const savedVariant = variants.find(
      (variant) => String(variant.id) === String(saved?.variantId || '')
    );

    if (sizeIndex >= 0 && !selectedSize) return { error: 'Select a size first.' };

    let variant = null;
    if (sizeIndex >= 0) {
      variant = variants.find((entry) => {
        if (String(entry.options?.[sizeIndex] || '') !== String(selectedSize)) return false;
        return optionDefinitions.every((option, index) => {
          if (index === sizeIndex) return true;
          const optionName = option.name || option;
          const savedValue = saved?.options?.[optionName] || savedVariant?.options?.[index];
          return !savedValue || String(entry.options?.[index] || '') === String(savedValue);
        });
      });
    } else {
      variant = savedVariant || variants.find((entry) => entry.available);
    }

    if (!variant) return { error: 'This size is sold out.' };
    if (!variant.available) return { error: 'This size is sold out.' };

    const variantId = Number(variant.id);
    if (!Number.isSafeInteger(variantId) || variantId <= 0) {
      return { error: 'Unable to add to cart.' };
    }

    return { variant, variantId };
  };

  const updateCartCount = (cart) => {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon && !cartIcon.querySelector('.cart-count-bubble') && cart.item_count > 0) {
      const bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      cartIcon.appendChild(bubble);
    }

    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach((count) => {
      count.textContent = cart.item_count;
    });
    document.querySelectorAll('.cart-count-bubble .visually-hidden').forEach((count) => {
      count.textContent = `${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`;
    });
  };

  const addSavedItemToCart = async (variantId, cartDrawer) => {
    const sections = cartDrawer?.getSectionsToRender?.().map((section) => section.id).filter(Boolean) || [];
    const body = { id: Number(variantId), quantity: 1 };
    if (sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    });

    const data = await response.json().catch(() => null);
    if (!response.ok) {
      throw new Error(data?.description || 'Unable to add to cart.');
    }
    return data;
  };

  document.addEventListener('click', async (event) => {
    const card = event.target.closest('.sth-saved-card');
    if (!card) return;

    if (event.target.closest('[data-saved-remove]')) {
      write(read().filter((item) => savedKey(item) !== card.dataset.savedKey));
      card.remove();
      toast('Removed.');
      if (!read().length) renderPage();
      return;
    }

    const add = event.target.closest('[data-saved-add]');
    if (!add) return;
    event.preventDefault();

    const message = card.querySelector('[data-saved-message]');
    const selection = getCurrentSavedVariant(card);
    if (selection.error) {
      message.textContent = selection.error;
      toast(selection.error);
      return;
    }

    add.dataset.variantId = String(selection.variantId);
    add.disabled = true;
    add.textContent = 'Adding...';
    message.textContent = '';

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const addedItem = await addSavedItemToCart(selection.variantId, cartDrawer);
      const cartResponse = await fetch(window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js', {
        headers: { Accept: 'application/json' },
      });
      if (!cartResponse.ok) throw new Error('Unable to update cart.');
      const cart = await cartResponse.json();

      updateCartCount(cart);
      message.textContent = 'Added to cart.';
      toast('Added to cart.');
      add.textContent = 'Added';

      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'sth-saved',
          productVariantId: String(selection.variantId),
          cartData: addedItem,
        });
      } else if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'sth-saved',
          productVariantId: String(selection.variantId),
          cartData: addedItem,
        });
      }

      if (cartDrawer && addedItem?.sections && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(addedItem);
      }

      window.setTimeout(() => {
        if (!add.isConnected) return;
        add.textContent = 'Add to Cart';
        add.disabled = false;
      }, 1500);
    } catch (error) {
      const errorMessage = error?.message || 'Unable to add to cart.';
      message.textContent = errorMessage;
      toast(errorMessage);
      add.textContent = 'Add to Cart';
      add.disabled = false;
    }
  });
  const start = () => { updateUI(); renderPage(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


/* Keep the protection message and purchase controls in one normal-flow area. */
(() => {
  const normalizeProductActions = () => {
    document.querySelectorAll('.product__info-container').forEach((container) => {
      const actions = container.querySelector('.sth-product-actions');
      if (!actions) return;

      let area = actions.closest('.product-action-area');
      if (!area) {
        area = document.createElement('div');
        area.className = 'product-action-area';
        actions.parentNode.insertBefore(area, actions);
        area.appendChild(actions);
      }

      const bars = Array.from(container.querySelectorAll('.product-form__variant-meta'));
      const existingBar = area.querySelector('.sth-product-trust-bar');
      const trustBar = bars.find((bar) => bar !== existingBar) || existingBar || bars[0];

      bars.forEach((bar) => {
        if (bar !== trustBar) bar.remove();
      });

      if (trustBar) {
        trustBar.classList.add('sth-product-trust-bar');
        if (trustBar.parentNode !== area) area.insertBefore(trustBar, area.firstChild);
      }

      const message = container.querySelector('.xcotton-sp-pdp .xcotton-sp-message');
      if (!message) return;
      const protection = message.closest('.xcotton-sp-pdp') || message;
      if (protection.parentNode !== area) area.insertBefore(protection, actions);
    });
  };

  const startProductActionObserver = () => {
    normalizeProductActions();
    const observer = new MutationObserver(normalizeProductActions);
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('change', (event) => {
      if (!event.target.closest('.product__info-container')) return;
      window.setTimeout(normalizeProductActions, 0);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startProductActionObserver);
  } else {
    startProductActionObserver();
  }
})();
